import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { ShoppingCart, Star } from 'lucide-react';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const [categoriesData, setCategoriesData] = useState([]);
  const [animalsData, setAnimalsData] = useState([]);
  const [foodData, setFoodData] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [cartCount, setCartCount] = useState(0);


  useEffect(() => {
    fetchCategoriesData();
    fetchAnimalData();
    fetchFoodData();
    fetchCartData();
  }, []);

  const fetchCartData = async () => {
    const userId = localStorage.getItem('userId');

    if(userId){
    const querySnapshot = await getDocs(collection(db, userId));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setCartData(list)
 
    if (list?.length > 0) {
      list.map((val, ind) => {
        if (val?.productId == product?.id) {
          setCartCount(val?.quantity)
        }
      })
    }
}
  };

  const fetchCategoriesData = async () => {
    const querySnapshot = await getDocs(collection(db, "categories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setCategoriesData(list)
  };

  const showCategoryName = (id) => {
    const found = categoriesData.find((category) => category?.id == id);
    return found?.name
  }

  const fetchAnimalData = async () => {
    const querySnapshot = await getDocs(collection(db, "animalCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setAnimalsData(list)
  };

  const showAnimalName = (id) => {
    const found = animalsData.find((category) => category?.id == id);
    return found?.name
  }

  const fetchFoodData = async () => {
    const querySnapshot = await getDocs(collection(db, "foodCategories"));

    const list = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setFoodData(list)
  };

  const showFoodName = (id) => {
    const found = foodData.find((category) => category?.id == id);
    return found?.name
  }

  const decreaseCartCount = () => {
    const userId = localStorage.getItem('userId');

    if (userId) {
      cartData.map(async (val, ind) => {
        if (val?.productId == product?.id) {
          console.log('copy')

          if (val?.quantity == 1) {

            try {

              deleteDoc(doc(db, userId, val?.id));
              setCartCount(0)
              fetchCartData();

            } catch (error) {

            }

          } else {
            const cartDoc = doc(db, userId, val?.id);

            try {
              await updateDoc(cartDoc, {
                userId: userId,
                productId: product.id,
                name: product.name,
                category: product.category,
                food: product.food,
                animal: product.animal,
                price: product.price,
                stock: product.stock,
                image: product.image,
                sku: product.sku,
                quantity: val?.quantity - 1
              });

              fetchCartData();
            } catch (error) {

            }
          }
        }
      })
    } else {
      navigate("/account");
    }
  }

  const increaseCartCount = () => {
    const userId = localStorage.getItem('userId');

    if (userId) {
      cartData.map(async (val, ind) => {
        if (val?.productId == product?.id) {
          console.log('copy')
          const cartDoc = doc(db, userId, val?.id);

          try {
            await updateDoc(cartDoc, {
              userId: userId,
              productId: product.id,
              name: product.name,
              category: product.category,
              food: product.food,
              animal: product.animal,
              price: product.price,
              stock: product.stock,
              image: product.image,
              sku: product.sku,
              quantity: product.stock >= val?.quantity + 1 ? val?.quantity + 1 : product.stock
            });

            fetchCartData();
          } catch (error) {

          }
        }
      })
    } else {
      navigate("/account");
    }
  }


  const handleAddToCart = async (quantity) => {
    const userId = localStorage.getItem('userId');

    if (userId) {
      try {
        await addDoc(collection(db, userId), {
          userId: userId,
          productId: product.id,
          name: product.name,
          category: product.category,
          food: product.food,
          animal: product.animal,
          price: product.price,
          stock: product.stock,
          image: product.image,
          sku: product.sku,
          quantity: quantity
        });

        fetchCartData();

        toast({ title: 'Success', description: 'Product added to cart!' });
      } catch (err) {
        console.error("Error adding to cart:", err);
      }
    } else {
      navigate("/account");
    }

  };

  return (
    <Card className="h-100 shadow-sm border-0 product-card">
      <div className="position-relative overflow-hidden" style={{ height: '150px' }}>
        <Card.Img
          variant="top"
          src={product.image}
          alt={product.name}
          style={{
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease'
          }}
          className="product-image"
        />
        <div className="position-absolute bottom-0 end-0 m-3">
          {cartCount < 1 ? <button
            className="cart-icon-btn"
            onClick={() => handleAddToCart(1)}
          >
            <ShoppingCart size={16} />
          </button> :

            <div className="cartQuantityDiv">
              <button onClick={() => decreaseCartCount(product)} className='cartQuantityBtn1'>−</button>
              <span className='cartQuantityInput'>{cartCount}</span>
              <button onClick={() => increaseCartCount(product)} className='cartQuantityBtn2'>+</button>
            </div>
          }

        </div>
      </div>
      <Card.Body className="d-flex flex-column">
        <div className="mb-1">
          <span className="badge bg-light text-dark small">{showCategoryName(product?.category)}</span>
          <span className="badge bg-light text-dark small mx-1">{showAnimalName(product?.animal)}</span>
          <span className="badge bg-light text-dark small">{showFoodName(product?.food)}</span>
        </div>
        <Card.Title className="fs-6 my-1">{product.name}</Card.Title>
        {/* <div className="d-flex align-items-center mb-1">
          <div className="d-flex me-2">
            {[...Array(5)].map((_, i) => (
              <Star 
                key={i} 
                size={10} 
                fill={i < Math.floor(product?.rating) ? '#FFD700' : 'none'}
                stroke={i < Math.floor(product?.rating) ? '#FFD700' : '#ccc'}
              />
            ))}
          </div>
          <span className="small text-muted">({product?.rating})</span>
        </div> */}
        <div className="mt-auto">
          <h5 className="text-primary mb-0 fs-6">₹{product.price.toFixed(2)}</h5>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;